import { engineComponent, StringUtils } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { ContainerStyle } from "../Components/Elements/Styles/ContainerStyle";
import { StyleManager } from "../Components/Managers/StyleManager";
import { BaseElement } from "../Components/Elements/Graphics/BaseElement";
import { Scaling } from "../Utils/Scaling";

@engineComponent(ComponentTypes.DisplayObject)
export class PortraitLayout extends ContainerElement {
    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private portraitProperties: { [id: string]: Element };

    private landscapeProperties: { [id: string]: Element };

    private inPortrait: boolean;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor() {
        super();

        this.portraitProperties = {};
        this.landscapeProperties = {};
        this.inPortrait = false;
    }

    //******************************************************************************************************************
    //  CREATE
    //******************************************************************************************************************

    create(node: Element): void {
        if (node.hasAttribute("Style")) {
            // get style from StyleManager
            this.style = <ContainerStyle>StyleManager.Styles[node.getAttribute("Style")];
            if (this.style != null) {
                this.parsePortraitLayoutStyles(this.style.node);
            }

            node.removeAttribute("Style");
        }

        super.create(node);
    }

    //******************************************************************************************************************
    //  FUNCTIONS
    //******************************************************************************************************************

    public init(parent: ContainerElement): void {
        const self = this;

        this.parseLandscapeLayoutStyles(parent);
        Scaling.Emitter.on(Scaling.EventResize, (isPortrait: boolean) => {
            self.updateLayout(isPortrait, parent);
        });

        this.updateLayout(Scaling.isPortrait(), parent);
    }

    private updateLayout(isPortrait: boolean, parent: ContainerElement): void {
        if (isPortrait && !this.inPortrait) {
            this.inPortrait = true;

            for (let key in this.portraitProperties) {
                let element = <BaseElement>parent.childs[key];
                this.updateContainer(
                    this.portraitProperties[key].getAttribute(PortraitLayoutAttributes.MOVE_TO),
                    element,
                    parent,
                    this.inPortrait,
                );
            }

            for (let key in this.portraitProperties) {
                let element = <BaseElement>parent.childs[key];
                element.updateByNode(this.portraitProperties[key]);
            }
        } else if (!isPortrait && this.inPortrait) {
            this.inPortrait = false;

            for (let key in this.landscapeProperties) {
                let element = <BaseElement>parent.childs[key];
                element.updateByNode(this.landscapeProperties[key]);
            }

            for (let key in this.landscapeProperties) {
                let element = <BaseElement>parent.childs[key];
                this.updateContainer(
                    this.landscapeProperties[key].getAttribute(PortraitLayoutAttributes.MOVE_TO),
                    element,
                    parent,
                    this.inPortrait,
                );
            }
        }
    }

    private parsePortraitLayoutStyles(node: Element): void {
        if (node != null && node["children"] != null) {
            let children = <HTMLCollection>node["children"];

            for (let i = 0; i < children.length; i++) {
                let child = <Element>children.item(i);

                if (child != null) {
                    let elementNode = document.createElement(child.nodeName);

                    for (let j = 0; j < child.attributes.length; j++) {
                        elementNode.setAttribute(child.attributes[j].name, child.attributes[j].value);
                    }

                    this.portraitProperties[child.nodeName] = elementNode;
                }
            }
        }
    }

    private updateContainer(
        containerId: string,
        element: BaseElement,
        parent: ContainerElement,
        inPortrait: boolean,
    ): void {
        if (!StringUtils.isNullOrEmpty(containerId)) {
            let container = parent.childs[containerId];

            if (container != null) {
                if (inPortrait) {
                    container.addChild(element);
                } else {
                    let containerIndex = parent.getChildIndex(container);
                    parent.addChildAt(element, containerIndex - 1);
                }
            }
        }
    }

    private parseLandscapeLayoutStyles(parent: ContainerElement): void {
        for (let key in this.portraitProperties) {
            this.landscapeProperties[key] = <Element>this.portraitProperties[key].cloneNode(true);

            let node = this.landscapeProperties[key];
            let element = parent.childs[key];

            if (node != null && element != null) {
                for (let i = 0; i < node.attributes.length; i++) {
                    switch (node.attributes[i].name) {
                        case "x":
                            node.attributes[i].value = element.x.toString();
                            break;
                        case "y":
                            node.attributes[i].value = element.y.toString();
                            break;
                        case "pivotx":
                            node.attributes[i].value = element.pivot.x.toString();
                            break;
                        case "pivoty":
                            node.attributes[i].value = element.pivot.y.toString();
                            break;
                        case "scale":
                            node.attributes[i].value = element.scale.x.toString();
                            break;
                        case "scalex":
                            node.attributes[i].value = element.scale.x.toString();
                            break;
                        case "scaley":
                            node.attributes[i].value = element.scale.y.toString();
                            break;
                        case "visible":
                            node.attributes[i].value = element.visible.toString();
                            break;
                    }
                }
            }
        }
    }
}

const PortraitLayoutAttributes = {
    MOVE_TO: "MoveTo",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/PortraitLayout.ts
 **/